<template>
  <div class="admin-view">
  <navigation-view></navigation-view>
    <div class="page">
      <div class="page-header">
        <div>
          <div class="page-title">สร้างการประชุม</div>
        </div>
      </div>

      <v-card class="data-card form-card">
        <v-card-text class="form-body">
          <v-form ref="form" v-model="formValid">
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <meeting-type-picker v-model="meeting.Type"></meeting-type-picker>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field
                  name="Title"
                  label="ชื่อการประชุม"
                  class="input-group--focused"
                  v-model="meeting.Title"
                  :rules="[v => !!v || 'กรุณากรอกชื่อการประชุม']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-menu
                  lazy
                  :close-on-content-click="false"
                  transition="v-scale-transition"
                  v-model="StartDate"
                  offset-y
                  full-width
                  :nudge-left="40"
                  max-width="290px"
                
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field lazy v-on="on" label="วันที่เริ่ม" v-model="meeting.StartDate"  prepend-icon="mdi-calendar" readonly :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่ม']" required></v-text-field>
                  </template>
                  <v-date-picker v-model="meeting.StartDate" color="primary" scrollable>
                    <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        @click="StartDate = false">
                        OK
                      </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md6 xs12>
                <v-menu
                  lazy
                  :close-on-content-click="false"
                  transition="v-scale-transition"
                  v-model="StartTime"
                  offset-y
                  full-width
                  :nudge-left="40"
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field 
                      lazy 
                      v-on="on" 
                      label="เวลาเริ่ม" 
                      v-model="meeting.StartTime" 
                      prepend-icon="mdi-clock" 
                      readonly
                      :rules="[v => !!v || 'กรุณาเลือกเวลาเริ่ม']" 
                      required
                      >
                    </v-text-field>
                  </template>
                  <v-time-picker v-model="meeting.StartTime" format="24hr" color="primary" scrollable>
                    <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        @click="StartTime = false">
                        OK
                      </v-btn>
                  </v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex md6 xs12>
                <v-menu
                  lazy
                  :close-on-content-click="false"
                  transition="v-g-transition"
                  v-model="EndDate"
                  offset-y
                  full-width
                  :nudge-left="40"
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field lazy v-on="on" label="วันที่สิ้นสุด" v-model="meeting.EndDate"  prepend-icon="mdi-calendar" readonly></v-text-field>
                  </template>
                  <v-date-picker v-model="meeting.EndDate" :min="meeting.StartDate || undefined" color="primary" scrollable>
                    <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        @click="EndDate = false">
                        OK
                      </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md6 xs12>
                <v-menu
                  lazy
                  :close-on-content-click="false"
                  transition="v-scale-transition"
                  v-model="EndTime"
                  offset-y
                  full-width
                  :nudge-left="40"
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field 
                      lazy 
                      v-on="on" 
                      label="เวลาสิ้นสุด" 
                      v-model="meeting.EndTime" 
                      prepend-icon="mdi-clock" 
                      readonly>
                    </v-text-field>
                  </template>
                  <v-time-picker v-model="meeting.EndTime" :min="endTimeMin" format="24hr" color="primary" scrollable>
                    <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        @click="EndTime = false">
                        OK
                      </v-btn>
                  </v-time-picker>
                </v-menu>
                
              </v-flex>
              
              <v-flex md12 xs12>
                <meeting-field-picker v-model="meeting.Fields" :is-admin="getUser.admin === 1"></meeting-field-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="form-actions">
          <v-spacer></v-spacer>
          <v-btn text large :disabled="saving" @click="cancel()">ยกเลิก</v-btn>
          <v-btn color="secondary" depressed large class="save-button cta-button" :disabled="saving" @click="save()">
            <v-icon left>mdi-content-save</v-icon>
            {{ saving ? 'กำลังบันทึก...' : 'บันทึก' }}
          </v-btn>
        </v-card-actions>

        <!-- กำลังสร้าง: นกบินวน · สร้างเสร็จ = วนครบรอบแล้วจางหาย -->
        <v-overlay absolute :value="showSavingOverlay" :dark="false" color="#FFFFFF" opacity="0.92">
          <div class="saving-overlay">
            <bird-orbit :size="120" :finishing="birdFinishing" class="saving-orbit" @done="onBirdDone"></bird-orbit>
            <div class="saving-title">กำลังสร้างการประชุม...</div>
            <div class="saving-hint">กรุณารอสักครู่</div>
          </div>
        </v-overlay>
      </v-card>
    </div>
    <!-- <v-btn color="primary" @click="showQRModal(qrLink)">Generate QR Code</v-btn> -->
    <v-dialog v-model="qrcodemeeting" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline dialog-title">QR Code ลงทะเบียน</v-card-title>
        <v-card-text style="text-align: center;">
          <v-alert type="success" text dense class="text-left">สร้างการประชุมสำเร็จ</v-alert>
          <img
              :src="qrcodeUrl"
              width="200"
              height="200"
              alt="QR Code"
            />
          <qr-instructions :type="meeting.Type"></qr-instructions>
          <v-text-field
            v-model="qrLink"
            label="ลิงก์ลงทะเบียน"
            :value="qrLink">
          </v-text-field>
          <v-btn color="primary" depressed @click="saveQrCode">
            <v-icon left>mdi-download</v-icon>
            บันทึก QR Code
          </v-btn>
          <!-- โหมดฉายหน้าห้อง (ปิดไว้ก่อน เปิดใช้: เอา comment ออกทั้งปุ่ม แท็ก <present-qr> import และ components)
          <v-btn color="secondary" depressed class="cta-button ml-2" @click="presentOpen = true">
            <v-icon left>mdi-projector-screen</v-icon>
            ฉายหน้าห้อง
          </v-btn> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeQRModal()">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-layout row justify-center>
      <v-dialog v-model="addProductModal" width="700" persistent>
        <v-card>
          <v-card-title>{{ modalTitle }}</v-card-title>
          <v-card-text>{{ modalText }}</v-card-text>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-select
                    required
                    v-bind:items="categories"
                    label="Category"
                    v-model="categoryId"
                    v-on:change="getProductsByCategory"
                  ></v-select>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select required v-bind:items="products" label="Product" v-model="productId"></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn class="green--text darken-1" text="text" @click.native="saveProduct">Confirm</v-btn>
            <v-btn class="orange--text darken-1" text="text" @click.native="cancelAddProduct">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout> -->

  <!-- <present-qr v-model="presentOpen" :link="qrLink" :title="meeting.Title || ''" :meeting-id="createdId"></present-qr> -->
  <footer-view></footer-view>
</div>
</template>
  
  
  <script>
  import NavigationView from '../../components/Navigation.vue'
  import FooterView from '../../components/Footer.vue';
  import axios from 'axios';

  import { API_URL } from '@/config';
  import { DEFAULT_FIELDS, buildThaidLink } from '@/meetingFields';
  import { endTimeMin, isEndDateBeforeStart, isEndTimeBeforeStart } from '@/dateRange';
  import MeetingFieldPicker from '../../components/MeetingFieldPicker.vue';
  import Swal from 'sweetalert2';
  import QRCode from 'qrcode';
  import { downloadQrPoster } from '@/qrPoster';
  import QrInstructions from '../../components/QrInstructions.vue';
  import BirdOrbit from '../../components/BirdOrbit.vue';
  import MeetingTypePicker from '../../components/MeetingTypePicker.vue';
  import { DEFAULT_TYPE, qrHeadline } from '@/meetingType';
  // import PresentQr from '../../components/PresentQr.vue';
  import { mapGetters } from 'vuex';

  export default {
    name: 'CreateMeetingView',
    components: {
      NavigationView,
      FooterView,
      MeetingFieldPicker,
      QrInstructions,
      BirdOrbit,
      MeetingTypePicker,
      // PresentQr,
    },
    
    computed: {
      ...mapGetters(['getUser']),
      endTimeMin() {
        return endTimeMin(this.meeting.StartDate, this.meeting.StartTime, this.meeting.EndDate);
      },
    },
    watch: {
      // เปลี่ยนวันเวลาเริ่มจนวันเวลาสิ้นสุดเดิมอยู่ก่อนหน้า: ล้างค่าสิ้นสุดให้เลือกใหม่
      'meeting.StartDate'() { this.clearInvalidEnd(); },
      'meeting.StartTime'() { this.clearInvalidEnd(); },
      'meeting.EndDate'() { this.clearInvalidEnd(); },
    },
    data() {
      return {
        StartDate: false,
        EndDate: false,
        StartTime: false,
        EndTime: false,
        meeting: {
          Type: DEFAULT_TYPE,
          Title: null,
          StartDate: null,
          EndDate: null,
          StartTime: null,
          EndTime: null,
          Fields: DEFAULT_FIELDS.slice()
        },
        qrcodemeeting: false,
        presentOpen: false,
        createdId: null,
        qrLink: 'https://www.google.com/',
        qrcodeUrl: "",
        formValid: false,
        saving: false,
        showSavingOverlay: false,
        birdFinishing: false,
      };
    },
    mounted() {
      if (!this.$store.state.user) {
        this.$router.push('/login');
      }
    },
    methods: {
      clearInvalidEnd() {
        const m = this.meeting;
        if (isEndDateBeforeStart(m.StartDate, m.EndDate)) {
          m.EndDate = null;
          m.EndTime = null;
        } else if (isEndTimeBeforeStart(m.StartDate, m.StartTime, m.EndDate, m.EndTime)) {
          m.EndTime = null;
        }
      },
      // ดาวน์โหลดเป็นรูปพร้อมชื่อการประชุมและวิธีสแกน (พิมพ์ติดหน้าห้องได้เลย)
      saveQrCode() {
        downloadQrPoster(this.qrLink, this.meeting.Title, qrHeadline(this.meeting.Type));
      },
      showQRModal(link){
        this.qrcodemeeting = true;
        QRCode.toDataURL(link, (err, url) => {
          if (err) {
            console.error(err);
            return;
          }
          this.qrcodeUrl = url;
        });          
      },
      closeQRModal(){
        this.qrcodemeeting = false;
        this.$router.push('ListMeeting');
      },
      // นกวนครบรอบและจางหายแล้ว: ปิดหน้าโหลด แล้วค่อยเปิดหน้าต่าง QR
      onBirdDone() {
        this.showSavingOverlay = false;
        this.birdFinishing = false;
        this.saving = false;
        this.showQRModal(this.qrLink);
      },
      stopSaving() {
        this.showSavingOverlay = false;
        this.saving = false;
      },
      async save(){
        if (this.saving) return;
        if (this.$refs.form.validate()) {
          const dataMeeting = {
            Title: this.meeting.Title,
            StartDate: this.meeting.StartDate,
            EndDate: this.meeting.EndDate,
            StartTime: this.meeting.StartTime,
            EndTime: this.meeting.EndTime,
            Fields: this.meeting.Fields,
            Type: this.meeting.Type,
            UserId: this.getUser.id
          }
          this.saving = true;
          this.showSavingOverlay = true;
          try{
            const res = await axios.post(`${API_URL}/createmeeting`, dataMeeting);

            if (res.data.responsecode == 200){
              // ใช้รายการที่ backend บันทึกจริง (ตัดข้อมูลกลุ่มแอดมินออกแล้วถ้าไม่ใช่แอดมิน)
              this.qrLink = buildThaidLink(res.data.id, res.data.data.fields || this.meeting.Fields);
              this.createdId = res.data.id;
              // รอนกวนครบรอบแล้วจางหาย -> onBirdDone เปิดหน้าต่าง QR
              this.birdFinishing = true;
            }
            else {
              this.stopSaving();
              Swal.fire({
                title: "บันทึกข้อมูลไม่สำเร็จ",
                text: res.data.reason,
                icon: "warning",
                confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
              });
            }

          }catch (error) {
            this.stopSaving();
            console.error('Error:', error);
          }
      }
        
        

      },
      cancel() { 
         this.$router.push('ListMeeting');
      },
    },
    
  }
  </script>
  
  <style scoped>
  .form-body {
    padding: 24px 24px 8px !important;
    font-size: 16px;
  }

  .form-actions {
    padding: 16px 24px !important;
  }

  @media (max-width: 599px) {
    .form-body {
      padding: 12px 8px 4px !important;
    }

    .form-actions {
      padding: 12px 16px !important;
    }
  }

  .save-button {
    min-width: 140px !important;
    border-radius: 999px;
    letter-spacing: 0;
    font-weight: 600;
  }

  .v-text-field {
    margin-bottom: 12px;
  }

  .saving-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .saving-title {
    margin-top: 20px;
    color: #0C2F53;
    font-size: 18px;
    font-weight: 600;
  }

  .saving-hint {
    margin-top: 4px;
    color: #5B6B7F;
    font-size: 14px;
  }
  </style>
  